module.exports = __webpack_public_path__ + "static/media/logos_squares_Sup_CIC.4606ab8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Sup_CIC.png
// module id = 72
// module chunks = 0